import { IData } from '../../../utils/create-dataParser/dataParser.util';
import { IAction } from '../root/i-action';
import { IState } from '../root/state.interface';
import {
  IGetFacilitiesResponse,
  IGetZonesResponse,
  IGetGroupTypesResponse,
  IGetGroupsResponse,
  IGroupType,
  IFormattedGroup,
  IGroupsTreeResponse,
  IZone,
  ILogicalReader,
  IPolygon,
  IGetMapOriginResponse,
  IGetMapImageResponse,
  IGetMapImageImageResponse,
} from './i-facility';
import { parseData } from '../../../utils/create-dataParser';

export const resetImageValuesFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  mapOrigin: {
    data: {
      id: 0,
      group_id: '',
      name: '',
      longitude: 0,
      latitude: 0,
      elevation: 0,
      azimuth: 0,
      units: '',
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});
export const resetImageValues = (state: IState): IState => ({
  ...state,
  mapOrigin: {
    data: {
      id: undefined,
      group_id: '',
      name: '',
      longitude: undefined,
      latitude: undefined,
      elevation: undefined,
      azimuth: undefined,
      units: '',
    },
    loading: false,
    error: undefined,
  },
  mapImage: {
    data: {
      id: 0,
      mapOrigin_id: undefined,
      xofffset: undefined,
      yoffset: undefined,
      theta: undefined,
      pixelsPerLength: undefined,
    },
    loading: false,
    error: undefined,
  },
  mapImageImage: {
    data: {},
    loading: false,
    error: undefined,
  },
});

export const resetMapReportValues = (state: IState): IState => ({
  ...state,
  mapReport: {
    data: {
      code: '',
      name: '',
      description: '',
      collection: '',
      filter: '',
      sort: '',
      limit: 0,
      count: 0,
      columnMap: {},
      recordsMap: {},
    },
    loading: false,
    error: undefined,
  },
});

export const getZonesListStart = (state: IState): IState => ({
  ...state,
  zones: {
    data: {
      data: [],
      propertyNames: [],
      count: 0,
    },
    loading: true,
    error: undefined,
  },
});

export const getZonesListSuccessNew = (state: IState, action: IAction): IState => {
  // eslint-disable-next-line
  const data = action.payload as any[];
  // eslint-disable-next-line
  data.forEach((p: any) => {
    // eslint-disable-next-line
    p.propertiesAsText = p.properties.reduce((a: string, c: any, i: number) => {
      const pair = `${c.name}=${c.value}`;
      return i === 0 ? pair : `${a}\n${pair}`;
    }, '');
    // eslint-disable-next-line
    p.logicalReadersAsText = p.logicalReaders.reduce((a: string, c: any, i: number) => {
      const pair = `${c.name}${c.direction ? `:${c.direction}` : ''}`;
      return i === 0 ? pair : `${a}\n${pair}`;
    }, '');
    // eslint-disable-next-line
    p.polygonsAsText = p.polygons.reduce((a: string, c: any, i: number) => {
      return i === 0 ? c.points : `${a}\n${c.points}`;
    }, '');
  });
  return {
    ...state,
    zonesNew: {
      data,
      loading: false,
    },
  };
};

export const getZonesListSuccess = (
  state: IState,
  action: IAction<{data:IGetZonesResponse, groupId:string}>,
): IState => {
  if (!action.payload.data.records.length) {
    return {
      ...state,
      zones: {
        ...state.zones,
        loading: false,
        loaded: true,
        error: undefined,
      },
    };
  }
  const data:IData = parseData(action.payload.data);
  const propertyNames = new Set<string>();
  const formattedData = data.map((zone : IZone) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newZone : any = { ...zone };
    if (Array.isArray(zone.properties) && zone.properties?.length) {
      zone.properties.forEach((property : {name:string, value:string}) => {
        newZone[property?.name] = property?.value;
        propertyNames.add(property.name);
        return newZone;
      });
    }
    return newZone;
  });
  const zones = {
    data: formattedData,
    count: action.payload.data.count,
    propertyNames: [...propertyNames],
  };

  return ({
    ...state,
    zones: {
      data: zones,
      loading: false,
      error: undefined,
      loaded: true,
    },
    groups: {
      ...state.groups,
      data: {
        ...state.groups.data,
        [action.payload.groupId]: {
          ...state.groups.data[action.payload.groupId],
          zones,
        },
      },
    },
  });
};

export const getZonesListFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  zones: {
    data: {
      data: [],
      propertyNames: [],
      count: 0,
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getFacilitiesListStart = (state: IState): IState => ({
  ...state,
  facilities: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const getFacilitiesListSuccess = (
  state: IState,
  action: IAction<IGetFacilitiesResponse>,
): IState => {
  const data = parseData(action.payload);

  return {
    ...state,
    facilities: {
      data,
      loading: false,
      error: undefined,
      loaded: true,
    },
  };
};

export const getFacilitiesListFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  facilities: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const editGroupStart = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: true,
  },
});

export const editGroupSuccess = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: false,
  },
});

export const editGroupFail = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: false,
  },
});

export const deleteGroupStart = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: true,
  },
});

export const deleteGroupSuccess = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: false,
  },
});

export const deleteGroupFail = (state:IState):IState => ({
  ...state,
  groups: {
    ...state.groups,
    loading: false,
  },
});

export const getGroupTypesListStart = (state: IState): IState => ({
  ...state,
  groupTypes: {
    data: {},
    loading: true,
    error: undefined,
    // loaded: true,
  },
});

export const getGroupTypesListSuccess = (
  state: IState,
  action: IAction<IGetGroupTypesResponse>,
): IState => {
  const data : {[key:string]: IGroupType} = {};
  action.payload.forEach(((type) => {
    data[type.id] = type;
  }));

  return ({
    ...state,
    groupTypes: {
      data,
      loading: false,
      error: undefined,
      loaded: true,
    },
  });
};
export const getGroupTypesListFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  groupTypes: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getGroupsListStart = (state: IState): IState => ({
  ...state,
  groups: {
    data: {},
    loading: true,
    error: undefined,
    // loaded: true,
  },
});

export const getGroupsListSuccess = (
  state: IState,
  action: IAction<IGetGroupsResponse>,
): IState => {
  const data : IFormattedGroup = {};

  action.payload.forEach(((group) => {
    const groupType = state.groupTypes.data[group.groupType_id];
    // state.groupsByTypes.data[groupType?.name].push(group.id);
    data[group.id] = {
      ...group,
      groupType,
    };
  }));

  return ({
    ...state,
    groups: {
      data,
      loading: false,
      error: undefined,
      loaded: true,
    },
  });
};

export const getGroupsListFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  groups: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getGroupsTreeListFail = (
  state: IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  groupsTree: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getGroupsTreeListStart = (state: IState): IState => ({
  ...state,
  groupsTree: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const getGroupsTreeListSuccess = (
  state: IState,
  action: IAction<IGroupsTreeResponse>,
): IState => ({
  ...state,
  groupsTree: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const createZoneRequest = (state:IState): IState => ({
  ...state,
  zones: {
    ...state.zones,
    loading: true,
  },
});

export const createZoneSuccess = (state:IState): IState => ({
  ...state,
  zones: {
    ...state.zones,
    loading: false,
  },
});

export const createZoneFail = (state:IState): IState => ({
  ...state,
  zones: {
    ...state.zones,
    loading: false,
  },
});

export const getLogicalReadersStart = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: true,
  },
});

export const getLogicalReadersSuccess = (
  state:IState,
  action:IAction<ILogicalReader[]>,
): IState => {
  const data : {[key:string]:ILogicalReader[]} = {};

  action.payload.forEach((reader) => {
    const link = data[reader.zone_id];
    if (data[reader.zone_id]) {
      link.push({ ...reader, order: link.length + 1 });
      return;
    }
    data[reader.zone_id] = [{ ...reader, order: 1 }];
  });
  return ({
    ...state,
    logicalReaders: {
      ...state.logicalReaders,
      data,
      loading: false,
    },
  });
};

export const getLogicalReadersFail = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

export const createGroupTypeStart = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: true,
  },
});

export const createGroupTypeSuccess = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: false,
  },
});

export const createGroupTypeFail = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: false,
  },
});

export const editGroupTypeStart = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: true,
  },
});

export const editGroupTypeSuccess = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: false,
  },
});

export const editGroupTypeFail = (state:IState): IState => ({
  ...state,
  groupTypes: {
    ...state.groupTypes,
    loading: false,
  },
});

export const deleteLogicalReaderStart = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: true,
  },
});

export const deleteLogicalReaderSuccess = (
  state:IState,
): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

export const deleteLogicalReaderFail = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

export const editLogicalReaderStart = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: true,
  },
});

export const editLogicalReaderSuccess = (
  state:IState,
  action:IAction<{zone_id:number, id:number, data : {name:string}}>,
): IState => {
  const { zone_id, id, data } = action.payload;
  const newData = Object.assign(state.logicalReaders.data);
  newData[zone_id] = newData[zone_id].map(((reader:ILogicalReader) => {
    if (id === reader.id) {
      return ({ ...reader, ...data });
    }
    return reader;
  }));

  return ({
    ...state,
    logicalReaders: {
      ...state.logicalReaders,
      data: newData,
      loading: false,
    },
  });
};

export const editLogicalReaderFail = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

export const getPolygonsStart = (state:IState): IState => ({
  ...state,
  polygons: {
    ...state.polygons,
    loading: true,
  },
});

export const getPolygonsSuccess = (
  state:IState,
  action:IAction<IPolygon[]>,
): IState => ({
  ...state,
  polygons: {
    ...state.polygons,
    data: action.payload,
    loading: false,
  },
});

export const getPolygonsFail = (state:IState): IState => ({
  ...state,
  polygons: {
    ...state.polygons,
    loading: false,
  },
});

export const deletePolygonStart = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: true,
  },
});

export const deletePolygonSuccess = (
  state:IState,
  action:IAction<{zone_id:number, id:number}>,
): IState => {
  const { zone_id, id } = action.payload;
  const data = Object.assign(state.logicalReaders.data);
  data[zone_id] = data[zone_id].filter(((reader:ILogicalReader) => id !== reader.id));

  return ({
    ...state,
    logicalReaders: {
      ...state.logicalReaders,
      data,
      loading: false,
    },
  });
};

export const deletePolygonFail = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

export const editPolygonStart = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: true,
  },
});

export const editPolygonSuccess = (
  state:IState,
): IState => ({
  ...state,
  polygons: {
    ...state.polygons,
  },
});

export const editPolygonFail = (state:IState): IState => ({
  ...state,
  logicalReaders: {
    ...state.logicalReaders,
    loading: false,
  },
});

// Map Origin Actions
export const createMapOriginRequest = (state:IState): IState => ({
  ...state,
  mapOrigin: {
    ...state.mapOrigin,
    loading: true,
  },
});
export const createMapOriginSuccess = (
  state:IState,
  action: IAction<IGetMapOriginResponse>,
): IState => ({
  ...state,
  mapOrigin: {
    data: action.payload,
    loading: false,
  },
});
export const createMapOriginFail = (
  state:IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  mapOrigin: {
    data: {
      id: undefined,
      group_id: '',
      name: '',
      longitude: undefined,
      latitude: undefined,
      elevation: undefined,
      azimuth: undefined,
      units: '',
    },
    loading: false,
    error: action.payload,
  },
});

// Map Image Actions
export const createMapImageRequest = (state:IState): IState => ({
  ...state,
  mapImage: {
    ...state.mapImage,
    loading: true,
  },
});
export const createMapImageSuccess = (
  state:IState,
  action: IAction<IGetMapImageResponse>,
): IState => ({
  ...state,
  mapImage: {
    data: action.payload,
    loading: false,
  },
});
export const createMapImageFail = (
  state:IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  mapImage: {
    data: {
      id: undefined,
      mapOrigin_id: undefined,
      xofffset: undefined,
      yoffset: undefined,
      theta: undefined,
      pixelsPerLength: undefined,
    },
    loading: false,
    error: action.payload,
  },
});

// ImageImage Actions
export const createMapImageImageRequest = (state:IState): IState => ({
  ...state,
  mapImageImage: {
    data: {},
    loading: true,
    error: undefined,
  },
});
export const createMapImageImageSuccess = (
  state:IState,
  action: IAction<IGetMapImageImageResponse>,
): IState => ({
  ...state,
  mapImageImage: {
    data: action.payload,
    loading: false,
  },
});
export const createMapImageImageFail = (
  state:IState,
  action: IAction<Error>,
): IState => ({
  ...state,
  mapImageImage: {
    data: {},
    loading: false,
    error: action.payload,
  },
});

export const createZoneForMapsRequest = (state:IState): IState => ({
  ...state,
  mapImageImage: {
    ...state.mapImageImage,
    loading: true,
  },
});
export const createZoneForMapsSuccess = (
  state:IState,
  action: IAction<IGetMapImageImageResponse>,
): IState => ({
  ...state,
  mapImageImage: {
    data: action.payload,
    loading: false,
  },
});
export const createZoneForMapsFail = (state:IState): IState => ({
  ...state,
  mapImageImage: {
    ...state.mapImageImage,
    loading: false,
  },
});
